import React from 'react';
export function Footer() {
  return <footer className="bg-[#14110c] text-cream/50 py-10 pb-8 text-center text-[13px]" data-id="element-156">
      <div className="container-custom" data-id="element-157">
        <div className="font-serif text-gold-light text-[17px] mb-2.5 font-medium" data-id="element-158">
          El Origen de Tus Bloqueos
        </div>
        <p className="mb-4 leading-[1.6] max-w-[560px] mx-auto" data-id="element-159">
          El primer sistema en español para trazar el origen generacional de tus
          patrones — sola, en privado, con base científica.
        </p>
        <p className="italic text-[12px] mb-6" data-id="element-160">
          "Lo que no procesaron tus ancestros, viaja hasta vos. Y si viajó, se
          puede interrumpir."
        </p>
        <div className="mt-6 pt-6 border-t border-cream/10 flex flex-wrap justify-center gap-x-4 gap-y-2" data-id="element-161">
          <span data-id="element-162">© 2026 El Origen de Tus Bloqueos</span>
          <span className="hidden sm:inline" data-id="element-163">·</span>
          <a href="#" className="text-cream/50 no-underline hover:text-cream/80 transition-colors" data-id="element-164">
            Política de privacidad
          </a>
          <span className="hidden sm:inline" data-id="element-165">·</span>
          <a href="#" className="text-cream/50 no-underline hover:text-cream/80 transition-colors" data-id="element-166">
            Términos
          </a>
        </div>
      </div>
    </footer>;
}